import hooks from './user.hooks';
import createSchema from './user.schema';

export default (app) => {
  const service = app.service('api/user');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
